






import * as moment from 'moment';
import { Vue, Component } from 'vue-property-decorator';
import { mdbSelect } from '@folky-tools/mdbvue';

@Component({ components: { mdbSelect } })
export default class LanguageSelector extends Vue {
    private languages: LanguageOption[] = [
        { text: 'EN (English)', value: 'en-GB', selected: false },
        { text: 'ES (Castellano)', value: 'es-ES', selected: false },
        { text: 'EU (Euskara)', value: 'eu-ES', selected: false }
        // { text: 'VA (Valencià)', value: 'ca-ES-valencia', selected: false }
    ];

    private beforeMount(): void {
        moment.locale(this.$i18n.locale);
        this.languages.find(l => l.value === this.$i18n.locale)!.selected = true;
    }

    private onLanguageChanged(value: string, text: string): void {
        this.$i18n.locale = value;
        moment.locale(this.$i18n.locale);
        this.$cookies.set(process.env.NODE_ENV === 'production' ? '.App.Culture' : `.App.MC-${process.env.NODE_ENV}.Culture`, value, '365d');
    }
}

interface LanguageOption {
    text: string;
    value: string;
    selected: boolean;
}
